import { Fragment } from 'react';

import { MetadataText, formatDuration } from '@spotify/confidence-core-react';
import { ProgressBar } from '@spotify/plugin-confidence-workflows-react';

type PlannedRuntimeProgressProps = {
  progress?: number | null;
  remainingDays?: number | null;
  currentRuntime?: number | null;
};

const remainingDaysLabel = (remainingDays: number | null | undefined) => {
  if (remainingDays === null || remainingDays === undefined) return null;
  if (remainingDays === 0) return 'Ending today';
  if (remainingDays === 1) return 'Ending tomorrow';
  if (remainingDays > 1) return `${formatDuration(remainingDays)} left`;
  return `${formatDuration(Math.abs(remainingDays))} overdue`;
};

export const PlannedRuntimeProgress = ({
  progress,
  remainingDays,
  currentRuntime,
}: PlannedRuntimeProgressProps) => {
  if (progress === null || progress === undefined) {
    return (
      <MetadataText
        items={[
          currentRuntime ? formatDuration(currentRuntime) : 'Just started',
        ]}
      />
    );
  }

  return (
    <Fragment>
      <ProgressBar variant="determinate" value={progress} color="secondary" />
      <MetadataText
        items={[`${progress}%`, remainingDaysLabel(remainingDays)]}
      />
    </Fragment>
  );
};
